import styled from 'styled-components';

export const Description = styled.p`
  margin: 0 0 4px;
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

export const ReasonButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ReasonChip = styled.button<{ $active: boolean }>`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  white-space: nowrap;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid ${({ $active, theme }) => {
    if ($active) return '#dc2626';
    return theme.mode === 'dark' ? '#374151' : '#e5e7eb';
  }};
  background: ${({ $active, theme }) => {
    if ($active) return 'rgba(220, 38, 38, 0.1)';
    return theme.mode === 'dark' ? '#1f2937' : '#ffffff';
  }};
  color: ${({ $active, theme }) => {
    if ($active) return '#dc2626';
    return theme.mode === 'dark' ? '#d1d5db' : '#475569';
  }};

  &:hover {
    border-color: #dc2626;
    color: #dc2626;
  }
`;

export const CustomTextarea = styled.textarea`
  width: 100%;
  min-height: 72px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  resize: vertical;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#1f2937')};

  &:focus {
    outline: none;
    border-color: #dc2626;
  }
`;

export const ModalButton = styled.button<{ $variant?: 'danger' | 'ghost' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;

  ${({ $variant = 'danger', theme }) => ($variant === 'ghost'
    ? `
      border: 1px solid ${theme.mode === 'dark' ? '#374151' : '#dcdfe4'};
      background: transparent;
      color: ${theme.mode === 'dark' ? '#e5e7eb' : '#374151'};

      &:hover:not(:disabled) {
        background: ${theme.mode === 'dark' ? 'rgba(255,255,255,0.06)' : '#f3f4f6'};
      }
    `
    : `
      border: 1px solid #dc2626;
      background: #dc2626;
      color: #ffffff;

      &:hover:not(:disabled) {
        background: #b91c1c;
      }
    `)}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const RefundBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#fde68a')};
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(245, 158, 11, 0.08)' : '#fffbeb')};
`;

export const RefundToggle = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    accent-color: #111827;
    flex-shrink: 0;
  }

  span {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#fbbf24' : '#92400e')};
  }
`;

export const AmountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AmountInput = styled.input`
  flex: 1;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#1f2937')};

  &:focus {
    outline: none;
    border-color: #111827;
  }
`;

export const AmountSuffix = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

export const Note = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

/* Sekcja powodu pod opisem okna potwierdzenia — odstęp, żeby pigułki nie kleiły się do tekstu. */
export const ReasonSection = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/* Mniejsze pigułki powodów — dodatek do potwierdzenia, nie jego główna treść. */
export const SmallChips = styled(ReasonButtons)`
  gap: 6px;

  button {
    padding: 4px 10px;
    font-size: 11.5px;
  }
`;
